import { NativeModules, Platform } from 'react-native';
import * as RNLocalize from 'react-native-localize';
import { hasNotch, getVersion, getBundleId, getDeviceType, hasDynamicIsland, } from 'utils/packages/rnDeviceInfo';
import Config from 'utils/packages/configs';
export const featureFlags = [
    // keep-sorted start
    'ab_apple_pay_sheet',
    'ab_blinkist_back',
    'ab_mini_value_proof',
    'ab_onboarding_report',
    'ab_onboarding_setup',
    'ab_flo_paywall_c1_inside',
    'ab_hide_view_all_plans_onboarding',
    'ab_paywall_before_and_after_choose_bank',
    'ab_test_emma_setup_basic_customers',
    'ab_test_emma_setup_free_trial_customers',
    'ab_choose_bank_intro_animated',
    'ab_payment_confirmation_modal',
    'ab_remove_screens',
    'ab_remove_screens_v2',
    'ab_discount_after_paywall',
    'ab_extend_trial',
    'ab_fair_price',
    'ab_intro_gift_feed',
    'ab_maximise_trial',
    'ab_partial_refund_new_copy',
    'ab_show_installed_bank_apps',
    'ab_skip_next_payment',
    'ab_ultimate_paywall',
    'account_pay_actions',
    'after_24hrs_promotion',
    'app_update_prompt',
    'asset_switch_v2',
    'auto_invest_v4',
    'automated_savings_v2',
    'autosave_select_period',
    'bank_logo_transaction',
    'buy_in_shares',
    'cash_isa_pot',
    'choose_bank_dec_2025',
    'choose_your_plan_version_b',
    'connections_limit_one_on_free',
    'credit_score',
    'credit_score_reports',
    'credit_score_alerts',
    'credit_score_feed_ab',
    'credit_score_history',
    'credit_score_recurring_payments',
    'credit_score_suggested_connections',
    'credit_score_switch_suggestions',
    'csv_imports',
    'current_account_switch_offers',
    'daily_bill_reminders',
    'direct_debit_provider',
    'discount_gift_after_onboarding',
    'dividend_reinvest',
    'employer_benefit_redemption',
    'energy_switch_two',
    'free_autosave_plus',
    'help_articles_config',
    'hide_funding_account_and_autoinvest_from_invest_onboarding',
    'hide_plus_view_all_plans',
    'in_app_rent_question',
    'instant_prorated_refunds',
    'invest_educational_videos',
    'invest_walkthrough_after_onboarding',
    'investment_providers',
    'isa_transfer',
    'JISA',
    'kyc_error_message',
    'learn_educational_content_v2',
    'limit_stop_orders',
    'live_export',
    'micro_modals',
    'min_autoinvest_amount',
    'min_deposit',
    'monevo_api',
    'monevo_us_api',
    'mortgages_habito',
    'most_popular_banks',
    'my_first_list',
    'new_budgeting_funnel',
    'new_onboarding_view_all_plans_v1',
    'new_referrals',
    'no_waiting',
    'onboarding_address',
    'onboarding_customise_emma_experience_questions',
    'onboarding_emma_profiling_questions',
    'onboarding_kyc_v2',
    'optimised_transaction_screen',
    'paywall_close_button_shown_late',
    'paywall_vs_modal',
    'phone_number_confirmation',
    'physical_assets',
    'plus_pricing_2025', // Used in backend don't remove
    'plus_pricing_2026', // Used in backend don't remove
    'plus_pro_prices_2026_08_12', // Used in backend don't remove
    'plus_pro_prices_2026_09_22', // Used in backend don't remove
    'pre_approved_transfers_consent_alignment',
    'premium_free_welcome_screen_2',
    'premium_on_walkthrough_ended',
    'premium_start_7_day_trial_button_text',
    'premium_web',
    'prompt_marketplace_review',
    'quotes_in_feed',
    'real_time_prices',
    'recurring_income',
    'recurring_offline_transactions_v2',
    'remove_x_to_skip_us_ab',
    'referrals_get_button_feed',
    'remove_pay_tab',
    'remove_pot_name_screen_v2',
    'rent_reporting_two',
    'reverse_trial',
    'rotating_quotes_ab',
    'seccl_onboarding_v3',
    'seccl_gia_ready_made_funds',
    'show_create_credit_builder_card',
    'show_subcategories_create_flow',
    'skip_free_trial_ab',
    'start_screen_emma_invest_apr2026',
    'step_by_step_paywall_f2',
    'still_deciding_modal',
    'stock_alerts',
    'stock_market_performance',
    'streaks_screen_ab',
    'streaks_screen_onboarding_v2',
    'stripe_plaid_ach',
    'subscription_via_stripe_android',
    'subscription_via_stripe_card_fallback',
    'subscription_via_stripe_ios',
    'subscriptions_in_feed',
    'suggest_instagram_merchant',
    'terms',
    'track_your_mortgage',
    'trading_account_info',
    'us_investments',
    'volatility_alert',
    'walkthrough_v6_v2',
    'warn_on_skip_are_you_sure_numbers',
    'warn_on_skip_are_you_sure_numbers_v2',
    'web_qr_code_scanner_in_settings',
    // keep-sorted end
];
// please keep this list sorted
export const commonFlags = [
    'apple_login',
    'facebook_login',
    'google_login',
    'phone_number_confirmation',
    'savings_max_interest',
];
export const defaultCategories = [
    'shopping',
    'transport',
    'groceries',
    'entertainment',
    'cash',
    'eatingout',
    'holidays',
    'health',
    'housing',
    'bills',
    'charity',
    'investments',
    'education',
    'family',
    'business',
    'income',
    'general',
    'internal',
    'transfer',
];
export const bundleId = getBundleId();
// used for Siri shortcuts
export const transactionsActivityType = `${bundleId}.AllTransactions`;
export const subscriptionsActivityType = `${bundleId}.Subscriptions`;
// Flags used for checking if the user has rated/reviewed
export const HAS_RATED_VIA_ALERT = 'HAS_RATED_APP_FLAG';
export const HAS_REVIEWED_ON_MARKETPLACE = 'HAS_REVIEWED_ON_MARKETPLACE';
export const appVersion = getVersion();
export const isRunningTestflight = !!NativeModules.BuildEnv?.isTestflight;
export const isIOS = Platform.OS === 'ios';
export const isWeb = Platform.OS === 'web';
export const isAndroid = Platform.OS === 'android';
export const isDesktop = getDeviceType() === 'Desktop';
export const keyboardAvoidingViewBehavior = isIOS ? 'padding' : undefined;
export const isDesktopOrWeb = isDesktop || isWeb;
export const emptyArray = [];
export const deviceHasNotch = hasNotch();
export const deviceHasDynamicIsland = hasDynamicIsland();
const { countryCode } = RNLocalize.getLocales()[0];
export { countryCode };
export const isUKTimezone = RNLocalize.getTimeZone() === 'Europe/London';
export const isEmmaDev = Config?.IS_PROD === 'false';
